module.exports = __webpack_public_path__ + "media/img/home/product/product3-323554f664f63ed2084fe963cf3b77da.svg";